import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceMonitoringHistoryLogsService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-monitoring`;

    static getInstance() {
        if (!ComplianceMonitoringHistoryLogsService.instance) {
            ComplianceMonitoringHistoryLogsService.instance = new ComplianceMonitoringHistoryLogsService();
        }

        return ComplianceMonitoringHistoryLogsService.instance;
    }

    async fetchLogs(params = {}) {
        const response = await axios.get(
            `${KYB_API_BASE_URL}/logs`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data || [];
    }
}
